module.exports = __webpack_public_path__ + "static/tablet-index-7c31dab4dd3aeee7e2a75313bebbb7ed.png";